import {type RouteLocationStringParam} from 'vue-router';
import {ROUTE_REF_PARAM_DEFINITION} from '../utils/portuna';

const NavigationEdit = () => import('../views/navigation/NavigationEdit.vue');

let meta = {module: 'navigation'};

let navigation = [
    {
        path: '/navigation/edit/:id(\\d+)?/' + ROUTE_REF_PARAM_DEFINITION,
        name: 'navigation-edit',
        component: NavigationEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                from: route.params.ref,
            };
        },
    },
    {
        path: '/navigation/add/:menuId(\\d+)/' + ROUTE_REF_PARAM_DEFINITION,
        name: 'navigation-add',
        component: NavigationEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                menuId: parseInt(route.params.menuId),
                from: route.params.ref,
            };
        },
    },
    // all other navigation routes redirect to navigation-edit
    {
        path: '/navigation/:wildcard*',
        redirect: {name: 'navigation-add'},
        meta,
    },
];

export default navigation;
